import {
  AuthPopupFixed,
  PopupTopper,
  SignUpContainerForm,
  SignUpWrapperSC,
} from '@setplex/arcane'
import { useUnit } from 'effector-react'
import { useState } from 'react'
import { SignUpForm } from './components/SignUpForm'
import { $isOpenedSignUpPopup, checkEnableToClose } from './model'

function SignUpPopupContent({ onClose }: { onClose: () => void }) {
  const [info, showInfo] = useState(false)

  return (
    <SignUpWrapperSC>
      <SignUpContainerForm>
        <PopupTopper
          onClose={info ? undefined : onClose}
          onBack={info ? () => showInfo(false) : undefined}
        />
        <SignUpForm info={info} onShowInfo={showInfo} />
      </SignUpContainerForm>
    </SignUpWrapperSC>
  )
}

SignUpPopup.displayName = 'SignUpPopup'
export function SignUpPopup() {
  const isOpenedSignUpPopup = useUnit($isOpenedSignUpPopup)

  const onClose = () => checkEnableToClose()

  return (
    <AuthPopupFixed
      wrapperId='sign-up'
      className='auth-popup-container-sign-up'
      isOpened={isOpenedSignUpPopup}
      onClickForClosingPopup={onClose}
    >
      <SignUpPopupContent onClose={onClose} />
    </AuthPopupFixed>
  )
}
